import { call, put, takeLatest } from 'redux-saga/effects';

import { DelayReason, DelayReasonService } from '../../../../../entities/DelayReason';
import {
  deleteDelayReasonRequest,
  getDelayReasonsError,
  getDelayReasonsSuccess,
  saveDelayReasonRequest,
} from './actions';
import { DELETE_DELAY_REASON_REQUEST, GET_DELAY_REASONS_REQUEST, SAVE_DELAY_REASON_REQUEST } from './constants';

function* loadDelayReasons() {
  try {
    const delayReasons: DelayReason[] = yield call(DelayReasonService.getDelayReasons);
    yield put(getDelayReasonsSuccess(delayReasons));
  } catch (error: any) {
    yield put(getDelayReasonsError(error));
  }
}

function* saveDelayReason(action: ReturnType<typeof saveDelayReasonRequest>) {
  try {
    const { delayReason } = action.payload;
    if (delayReason.id) {
      yield call(DelayReasonService.updateDelayReason, delayReason);
    } else {
      yield call(DelayReasonService.createDelayReason, delayReason);
    }
    const delayReasons: DelayReason[] = yield call(DelayReasonService.getDelayReasons);
    yield put(getDelayReasonsSuccess(delayReasons));
  } catch (error: any) {
    yield put(getDelayReasonsError(error));
  }
}

function* deleteDelayReason(action: ReturnType<typeof deleteDelayReasonRequest>) {
  try {
    yield call(DelayReasonService.deleteDelayReason, action.payload.id);
    const delayReasons: DelayReason[] = yield call(DelayReasonService.getDelayReasons);
    yield put(getDelayReasonsSuccess(delayReasons));
  } catch (error: any) {
    yield put(getDelayReasonsError(error));
  }
}

export function* delayReasonsTabSagaWatcher() {
  yield takeLatest(GET_DELAY_REASONS_REQUEST, loadDelayReasons);
  yield takeLatest(SAVE_DELAY_REASON_REQUEST, saveDelayReason);
  yield takeLatest(DELETE_DELAY_REASON_REQUEST, deleteDelayReason);
}
